<div class="login-container text-center">
    <main class="form-signin">
        <img class="mb-4" src="assets/images/surefire-logo.svg" alt="Surefire Logo" />
        <h1 class="h3 mb-3 fw-normal">Access Denied</h1>

        <p class="small mt-3">
            Something went wrong during the authentication process. Please contact support at
            <a href="mailto:support@surfiresoftware.co.uk">support&#64;surfiresoftware.co.uk</a> or phone us at
            <a href="tel:02086394546">020 8639 4546</a>.
        </p>

        <p class="small mt-3">
            <button sfButton icon="sign-in" (click)="login()">Login</button>
            <button sfButton color="danger" icon="sign-out" (click)="logout()">Force Logout</button>
        </p>

        <p class="mt-5 mb-3 text-muted">Surefire Software © 2005–{{ year }}</p>
    </main>
</div>
